export const COUNTERS_FILTER = 'COUNTERS_FILTER'
export const BUSSTATION_LIST = 'BUSSTATION_LIST'
export const PLACE_LIST = 'PLACE_LIST'
export const CITY_CARGO_LIST = 'CITY_CARGO_LIST'
export const STATES_LIST = 'STATES_LIST';
export const STATES_TBL_DATA = 'STATES_TBL_DATA';
export const CORPORATION_LIST = 'CORPORATION_LIST'
export const CORPORATION_TBL_DATA = 'CORPORATION_TBL_DATA'
export const LEVIES_LIST_DATA = 'LEVIES_LIST_DATA'
export const LEVIES_CORP_LIST_DATA = 'LEVIES_CORP_LIST_DATA'
export const LEVIES_TBL_DATA = 'LEVIES_TBL_DATA'
export const CONCESSION_LIST = 'CONCESSION_LIST'
export const CONCESSION_TBL_DATA = 'CONCESSION_TBL_DATA'
export const PLACE_TABLEDATA = 'PLACE_TABLEDATA'
export const CREW_LIST = 'CREW_LIST'
export const DEPOT_LIST = 'DEPOT_LIST'
export const DIVISION_LIST = 'DIVISION_LIST'
export const CLASS_TYPE_LIST = 'CLASS_TYPE_LIST'
export const CLASS_TYPE_MASTER_LIST = 'CLASS_TYPE_MASTER_LIST'
export const VEHICLE_MAC = 'VEHICLE_MAC'
export const GROUP_DISCOUNT_LIST = 'GROUP_DISCOUNT_LIST'
export const CLASS_TYPE_LEVY_LIST = 'CLASS_TYPE_LEVY_LIST'
export const SEASON_TYPE_LIST = 'SEASON_TYPE_LIST'
export const AUDIT_MODULE_LIST = 'AUDIT_MODULE_LIST'
export const UPDATE_MASTER_CODE_LIST = 'UPDATE_MASTER_CODE_LIST'
export const PAYMENTGATEWAY_LIST = 'PAYMENTGATEWAY_LIST'
